import { render, staticRenderFns } from "./ReturnItemRow.vue?vue&type=template&id=3b57b4f6&scoped=true&"
import script from "./ReturnItemRow.vue?vue&type=script&lang=js&"
export * from "./ReturnItemRow.vue?vue&type=script&lang=js&"
import style0 from "./ReturnItemRow.vue?vue&type=style&index=0&id=3b57b4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57b4f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VBtnToggle,VChip,VExpandTransition,VIcon,VImg,VTextField})
